// extracted by mini-css-extract-plugin
export var loadingSpinner = "_45-1";
export var standaloneTable = "_45-0";